import {GraphObject, Link, Map} from 'gojs';

import {ParallelRouteLink} from 'src/util/gojs/extensions/ParallelRouteLink';
import {FixedRadiusParallelRouteLink} from 'src/util/gojs/extensions/FixedRadiusParallelRouteLink';

import {makeCommonLinkConfig} from './utils';

import type {LinkClickedEvent} from './utils';

const {make} = GraphObject;

export const makeLinkTemplateMap = ({
  onLinkClicked,
}: {
  onLinkClicked?: (_: LinkClickedEvent) => void,
}) => {
  const straight = make(
      FixedRadiusParallelRouteLink,
      {
        selectionAdorned: false,
        selectable: false,
      },
      ...makeCommonLinkConfig({onLinkClicked}),
  );

  const curved = make(
      FixedRadiusParallelRouteLink,
      {curve: Link.Bezier, corner: 20},
      ...makeCommonLinkConfig({onLinkClicked}),
  );

  const auto = make(
      ParallelRouteLink,
      {routing: Link.AvoidsNodes, corner: 20},
      ...makeCommonLinkConfig({onLinkClicked}),
  );

  const templmap = new Map<string, ParallelRouteLink>();
  templmap.add('straight', straight);
  templmap.add('curved', curved);
  templmap.add('auto', auto);
  return templmap;
};
